import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const OrderStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { order } = location.state || {};

  if (!order) {
    navigate("/mis-compras");
    return null;
  }

  const steps = [
    "Pedido registrado",
    "Pago inicial recibido",
    "Recogida pendiente",
    "Completado",
  ];

  return (
    <div className="flex flex-col items-center min-h-screen bg-white px-6 md:px-40 py-10">
      <div className="w-full max-w-[512px] p-6 bg-white shadow-md rounded-lg">
        <h2 className="text-center text-2xl font-bold mb-6">Estado del Pedido</h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          Pedido ID: {order.id} | Total: ${order.total.toFixed(2)}
        </p>

        {/* Timeline */}
        <div className="flex flex-col space-y-4">
          {steps.map((step, index) => {
            const completedIndex = steps.indexOf(order.status);
            let bgColor = "bg-gray-300";       // Pendiente
            let textColor = "text-gray-400";   // Pendiente

            if (index < completedIndex) {
              bgColor = "bg-green-600";       // Completado
              textColor = "text-gray-900";
            } else if (index === completedIndex) {
              bgColor = "bg-yellow-500";      // Paso actual
              textColor = "text-gray-900";
            }

            return (
              <div key={step} className="flex items-center">
                <div
                  className={`w-5 h-5 rounded-full border-2 mr-4 ${bgColor} border-gray-300`}
                />
                <span className={`text-sm font-medium ${textColor}`}>
                  {step}
                </span>
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={() => navigate("/mis-compras")}
            className="rounded-lg h-10 px-4 bg-gray-600 text-white font-bold text-sm"
          >
            Volver a Mis Compras
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderStatus;
